<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 19:24:35
-->
<template>
  <veStuCheckModify viewType="my" slot="table"></veStuCheckModify>
</template>

<script>
import veStuCheckModify from './base/veStuCheckModify';
export default {
  components: {
    veStuCheckModify
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
